import { render, staticRenderFns } from "./UserArrivalList.vue?vue&type=template&id=0b85cd47&scoped=true&"
import script from "./UserArrivalList.vue?vue&type=script&lang=js&"
export * from "./UserArrivalList.vue?vue&type=script&lang=js&"
import style0 from "./UserArrivalList.vue?vue&type=style&index=0&id=0b85cd47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85cd47",
  null
  
)

export default component.exports